import request from '@/utils/request'
import { oauthServerContext } from '@/config/config'
import { cmsServerContext } from '@/config/config'

export function login(username, password) {
  return request({
    url: oauthServerContext + '/oauth/token?grant_type=password&username=' + username + '&password=' + password,
    method: 'post',
    headers: {
      Authorization: 'Basic YXBwOjEyMzQ1Ng=='
    }
  })
}

export function loginWithRefreshToken(refreshToken) {
  return request({
    url: oauthServerContext + '/oauth/token?grant_type=refresh_token&refresh_token=' + refreshToken,
    method: 'post'
  })
}

export function getInfo(token) {
  return request({
    url: cmsServerContext + '/user/info',
    method: 'get'
  })
}

export function logout(token, refreshToken) {
  return request({
    url: oauthServerContext + '/token/revoke/' + token + '/' + refreshToken,
    method: 'post'
  })
}
